import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import useResizeObserver from 'use-resize-observer/polyfilled'
import React, { useRef } from 'react'
import { RefWrappedDigestMovieContent } from './Content'
import { useContext } from 'react'
import { WindowSizeContext } from '@context/WindowSize/Context'
import { BREAKPOINTS } from '@constants/common'

type Props = {
  youtubeId: string
}

export const DigestMovie = ({ youtubeId }: Props): JSX.Element => {
  const { ref } = useResizeObserver<HTMLDivElement>()
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const winSize = useContext(WindowSizeContext)

  return (
    <div className="w-[87.2vw] lg:w-[62.6vw]" ref={ref}>
      <ProgramDescriptionAccordion
        title={
          winSize?.width > BREAKPOINTS.laptop
            ? '講師によるプログラムのポイント紹介'
            : '講師によるプログラムの\nポイント紹介'
        }
      >
        <RefWrappedDigestMovieContent {...{ youtubeId }} ref={iframeRef} />
      </ProgramDescriptionAccordion>
    </div>
  )
}
